import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// Attach JWT if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Resolve image URLs:
//  - absolute http(s): use as-is
//  - backend static (/api/...): prefix backend URL
//  - anything else (e.g. /tours/x.png in frontend public): frontend-relative, use as-is
export const imgUrl = (src) => {
  if (!src) return "";
  if (src.startsWith("http")) return src;
  if (src.startsWith("/api/")) return `${BACKEND_URL}${src}`;
  return src;
};

export const formatINR = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export default api;
